import classNames from "classnames";
import { OpensearchCuratedSearch } from "../../../__generated__/graphql";
import CuratedInternalSearchPowerUserFilters from "../../autopilotCuratedSearch/CuratedSearchFilters/PowerUserFilters/CuratedInternalSearchPowerUserFilters";
import PowerUserFiltersContext from "../../../contexts/PowerUserFiltersContext";

interface BulkAccountSearchFiltersProps {
  queryBlob: string;
  orgCompanyIds?: number[];
  companyNames?: string[];
  setSavedFilters: (value: OpensearchCuratedSearch | null) => void;
}

const BulkAccountSearchFilters = ({
  queryBlob,
  orgCompanyIds,
  companyNames,
  setSavedFilters,
}: BulkAccountSearchFiltersProps) => {
  // Provide a default query structure if queryBlob is empty
  const defaultQuery = JSON.stringify({
    combinator: "and",
    rules: [],
  });

  const savedFilters: OpensearchCuratedSearch = {
    opensearchFiltersBlob: queryBlob || defaultQuery,
    auxiliary_filters: {
      companyNames: companyNames || [],
      orgCompanyIds: orgCompanyIds || [],
    },
  };

  const handleSetSavedFilters = (value: OpensearchCuratedSearch) => {
    // Preserve orgCompanyIds and companyNames when updating filters
    const updatedFilters: OpensearchCuratedSearch = {
      ...value,
      auxiliary_filters: {
        ...value.auxiliary_filters,
        orgCompanyIds: orgCompanyIds || [],
        companyNames: companyNames || [],
      },
    };
    setSavedFilters(updatedFilters);
  };

  return (
    <div>
      <h4 className={classNames("text-md", "font-medium", "mb-4")}>
        Search filters
      </h4>
      <PowerUserFiltersContext.Provider value={{ showErrorMessages: true }}>
        <CuratedInternalSearchPowerUserFilters
          savedFilters={savedFilters}
          setSavedFilters={handleSetSavedFilters}
          disabled={false}
        />
      </PowerUserFiltersContext.Provider>
    </div>
  );
};

export default BulkAccountSearchFilters;
